import * as React from 'react';
import './edit-modal.scss';
import { Modal } from '../../../../../components/modal/modal';
import { Input, Spin } from 'antd';
import { changeOrderStatus } from '../../../../../core/repositories/orders-transactions';
import { Dropdown } from 'components/dropdown/dropdown';
import { Button, buttonType } from 'components/button/button';
import { Enum } from 'core/domain/commons/common';
import { Badge } from 'components/badge/badge';
import { Order } from 'core/domain';
import { getOrderTransactionStateBadgeType } from '../script';

interface Props {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    item: Order;
    onClose: () => void;
    orderStates: Enum[];
}

export const OrderEditModal: React.FC<Props> = ({ isOpen, setIsOpen, item, onClose, orderStates }) => {
    const [loading, setLoading] = React.useState(false);
    const [buttonLoading, setButtonLoading] = React.useState(false);
    const [iBan, setIBan] = React.useState<string>('');
    const [walletAddress, setWalletAddress] = React.useState<string>('');
    const [memoTag, setMemoTag] = React.useState<string>('');
    const [selectedState, setSelectedState] = React.useState<Enum | undefined>(undefined);

    const onCloseModal = () => {
        onClose();
        setIBan('');
    };

    React.useEffect(() => {
        isOpen === false && onCloseModal();
    }, [isOpen]);

    React.useEffect(() => {
        if (!orderStates || !item?.state) return;
        const match = orderStates.find((q) => q.id === item.state.id) ?? orderStates[0];
        setSelectedState(match);
    }, [orderStates, item]);

    return (
        <Modal className="order-edit-modal" isOpen={isOpen} setIsOpen={setIsOpen}>
            <Spin spinning={loading}>
                <h3>تغییر معامله</h3>
                <div className="row summary">
                    <span className="label">شناسه معامله</span>
                    <span className="en value">{item?.orderTransactionTrackingCode}</span>
                </div>
                <div className="row summary">
                    <span className="label">جفت ارز</span>
                    <span className="en value">
                        {item?.sourceSymbol} / {item?.destinationSymbol}
                    </span>
                </div>
                <div className="row summary">
                    <span className="label">وضعیت فعلی</span>
                    {item?.state && (
                        <Badge
                            text={item.state.title}
                            type={getOrderTransactionStateBadgeType(item.state.id)}
                        />
                    )}
                </div>
                <div className="row">
                    <label>وضعیت جدید</label>
                    {orderStates?.length > 0 && selectedState && (
                        <Dropdown
                            items={orderStates}
                            onChangeHandle={(value) =>
                                setSelectedState(orderStates.find((s) => s.id === value))
                            }
                            selectedOption={selectedState}
                        />
                    )}
                </div>
                {item.type.title === 'فروش' && (
                    <div className="row">
                        <label>شماره شبا</label>
                        <Input
                            placeholder="بدون IR وارد کنید"
                            value={iBan}
                            onChange={(e) => setIBan(e.target.value)}
                            maxLength={24}
                            dir="ltr"
                        />
                    </div>
                )}
                {item.destinationSymbol !== 'IRT' && item.destinationSymbol !== 'PM' && (
                    <>
                        <div className="row">
                            <label>آدرس کیف پول</label>
                            <Input
                                placeholder="آدرس مقصد"
                                value={walletAddress}
                                onChange={(e) => setWalletAddress(e.target.value)}
                                dir="ltr"
                            />
                        </div>
                        <div className="row">
                            <label>ممو تگ</label>
                            <Input
                                placeholder="در صورت نیاز"
                                value={memoTag}
                                onChange={(e) => setMemoTag(e.target.value)}
                                dir="ltr"
                            />
                        </div>
                    </>
                )}
                <div className="buttons">
                    <Button
                        loading={buttonLoading}
                        type={buttonType.info}
                        text="اعمال تغییرات"
                        onClick={async (e) => {
                            if (item.orderTransactionTrackingCode) {
                                await changeOrderStatus(
                                    setButtonLoading,
                                    {
                                        trackingCode: item.orderTransactionTrackingCode,
                                        memoTag: memoTag || null,
                                        walletAddress: walletAddress || null,
                                        state: selectedState ? selectedState.id : null,
                                        iban: iBan !== '' ? iBan.replaceAll('IR', '') : null,
                                    },
                                    (e) => {
                                        setIsOpen(false);
                                        setIBan('');
                                    },
                                );
                            }
                        }}
                    />
                    <Button type={buttonType.outlined} text="بازگشت" onClick={() => setIsOpen(false)} />
                </div>
            </Spin>
        </Modal>
    );
};
